import React, { PropTypes } from 'react';
// import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { authInfo, editShippingOptions } from '../../actions'
import { uploadImage } from '../../lib/upload';
import Dropzone from 'react-dropzone';
import { browserHistory } from 'react-router';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import DialogModal from '../home/DialogModal';
import RaisedButton from 'material-ui/RaisedButton';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import MenuItem from 'material-ui/MenuItem';
import _ from 'lodash';
import Alert from '../home/Alert';
import ShippingOptions from './ShippingOptions'
import CountDownOptions from './CountDownOptions'
import ProductionOptions from './ProductionOptions'
import UpsellOptions from './UpsellOptions'


const propTypes = {
  dispatch: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  taxStates: PropTypes.any,
  settings: PropTypes.object,
  error: PropTypes.any,
};
const dropzoneStyles = {
  border: '10px',
  boxSizing: 'border-box',
  display: 'inline-block',
  cursor: 'pointer',
  outline: 'none',
  position: 'relative',
  height: '36px',
  lineHeight: '36px',
  borderRadius: '2px',
  transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  backgroundColor: 'rgb(0, 188, 212)',
  textAlign: 'center',
  fontSize: '14px',
  letterSpacing: '0px',
  fontWeight: '500',
  margin: '0px',
  userSelect: 'none',
  paddingLeft: '16px',
  paddingRight: '16px',
  color: 'rgb(255, 255, 255)'
}

const clientOptions = {
  sessionCache: true
}
const client = window.filestack.init('AJPkbXMCpSHWIMU3KY6Ryz', clientOptions)
class ShowSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewRedirect: false,
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      open: false,
      openShipping: false,
      alertOpen: false,
      alertMessage: '',
      edited: false,
      required: {
      },
      controls: {
        taxStatesDisabled: true,
        taxByBillingAddressDisabled: true,
      },
      settings: {
        tenantId: '',
        orderToken: '',
        seoName: '',
        seoTitle: '',
        seoDescription: '',
        taxPickupOrders: false,
        taxShippedOrders: false,
        taxStates: [],
        taxByBillingAddress: false,
        clientLogo: '',
        heroImg: '',
        flatShippingRate: 0,
        setFreeShipping: false,
        theme: 'default',
        layout: 'default',
        productionCutoffHr: 0,
        productionCutoffMin: 0,
        productionSat: false,
        productionSatDeliv: false,
        promoText: '',
        promoText2: '',
        promoText3: '',
        promoSubtext: '',
        promoTextMobile: '',
        promoText2Mobile: '',
        promoText3Mobile: '',
        promoSubtextMobile: '',
        promoColor: '',
        promoHighlightColor: '',
        promoBackgroundColor: '',
        promoLink: '',
        countdownEndDate: '',
        countdownText1: '',
        countdownText2: '',
        countdownText3: '',
        countdownText1Mobile: '',
        countdownText2Mobile: '',
        countdownText3Mobile: '',
        countdownBackgroundColor: '',
        countdownTextColor: '',
        shippingOptions: [{
          name: '',
          description: '',
          price: '',
          free_cutoff: '',
          disabled: true,
        }],
        upsellSku: '',
        upsellDiscount: 1,
        upsellDescription: '',
        sendToProduction: true,
      },
      taxStates: [],
    };
    autoBind(this);
  }

  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }

  componentWillReceiveProps(nextProps) {
    const settings = nextProps.settings;
    const taxStates = nextProps.taxStates;
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        edited: false,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
        error: true,
      });
    }
    if (nextProps.settings && !nextProps.error && this.state.edited) {
      this.setState({
        alertOpen: true,
        alertMessage: 'Settings edited succesfully!',
        error: false,
        edited: false,
      });
    }
    this.setState({
      settings,
      taxStates,
    });
    this.setRules(settings);
  }
  setRules(data) {
    const required = this.state.required;
    const controls = this.state.controls;
    const settings = data;

    if (settings.taxPickupOrders || settings.taxShippedOrders) {
      required.taxStates = null;
      controls.taxStatesDisabled = false;
      if (settings.taxShippedOrders) {
        controls.taxByBillingAddressDisabled = false;
      } else {
        controls.taxByBillingAddressDisabled = true;
      }
    } else {
      delete required.taxStates;
      settings.taxStates = [];
      controls.taxStatesDisabled = true;
      controls.taxByBillingAddressDisabled = true;
    }
    this.setState({ required, controls, settings });
    // this.setRequiredParams();
  }
  handleChange(e) {
    const settings = this.state.settings;
    if (e.target.type === 'checkbox') {
      _.set(settings, e.target.name, e.target.checked);
    } else {
      _.set(settings, e.target.name, e.target.value);
    }
    this.setState({
      settings,
      edited: true,
    });
    this.setRules(settings);
  }
  handleUploadedImage(name, value) {
    const settings = this.state.settings;
    _.set(settings, name, value);
    this.setState({
      settings,
      edited: true,
    });
    this.setRules(settings);
  }
  handleShippingOptions(e) {
    const shipping = this.state.settings;
    if (e.target.type === 'checkbox') {
      _.set(shipping, e.target.name, e.target.checked);
    } else {
      _.set(shipping, e.target.name, e.target.value);
    }
    this.setState({
      shipping,
    });
  }
  saveShippingOptions(index) {
    const data = this.state.settings.shippingOptions[index]
    this.setState({ openShipping: true })
    this.props.dispatch(editShippingOptions(data))
      .then((res) => {
        setTimeout(() => {
          this.setState({ openShipping: false })
        }, 5000)
      })
  }
  handleSelectChange(event, index, value, t) {
    const settings = this.state.settings;
    if (Array.isArray(settings[t])) {
      (settings[t].includes(value)) ? _.pull(settings[t], value) : settings[t].push(value); // eslint-disable-line
    } else {
      settings[t] = value;
    }
    this.setState({
      settings,
      edited: true,
    });
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
    });
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Settings Changes';
    nextState.dialogMessage = 'Do you really want to save the changes to the settings?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: true,
    });
    const pSettings = this.state.settings;
    delete pSettings.tenantId;
    delete pSettings.orderToken;
    this.props.onSave(pSettings);
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
    });

    if (!this.state.error) {
      browserHistory.push('/settings');
    }
  }
  onDrop(file, bucket, name) {
    const { dispatch } = this.props
    const token = authInfo(dispatch)
    uploadImage(file, bucket, token, 0)
      .then((response) => {
        this.handleChange({
          target: {
            name: name,
            value: response.fileName
          }
        })
      })
      .catch((err) => {
        console.log('# got back ERROR from uploadImage: ', err);
        this.handleChange({
          target: {
            name: name,
            value: file[0].name
          }
        })
        alert(`Image upload failed: ${er}`);
        return '';
      });
  }
  renderShippingOptions() {
    const { settings } = this.state
    if (settings && settings.shippingOptions) {
      return settings.shippingOptions.map((shipping, i) => {
        return <ShippingOptions
          shipping={shipping}
          index={i}
          handleChange={this.handleShippingOptions}
          saveShippingOptions={this.saveShippingOptions}
          openShipping={this.state.openShipping}
        />
      })
    } else {
      return ("Loading...")
    }
  }
  render() {
    // const isDisabled = ['0', '1'].indexOf(localStorage.getItem('scope')) === -1;
    const isTrue = true;
    const isFalse = false;
    const taxStates = this.state.settings.taxStates;
    const stateSelect = _.map(this.state.taxStates, (ts, i) => <MenuItem
      value={ts}
      key={i}
      label={ts}
      primaryText={ts}
      checked={taxStates && taxStates.includes(ts)}
    />);
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inline: {
        display: 'flex',
        width: '70%',
      },
      inputStyle: {
        marginRight: '2%',
        width: '300px',
      },
      radioButton: {
        marginBottom: 16,
        float: 'left',
        display: 'inline-block',
        width: '190px',
      },
    };
    return (
      <div style={{ width: '100%' }}>
        <h2>Global Settings</h2>
        <div className="content">
          <Alert
            alertOpen={this.state.alertOpen}
            alertHandleClose={() => this.alertHandleClose()}
            alertMessage={this.state.alertMessage}
          />
          <DialogModal
            dialogOpen={this.state.open}
            dialogHandleClose={this.handleClose}
            dialogHandleSubmit={() => this.saveChanges()}
            dialogTitle={this.state.dialogTitle}
            dialogMessage={this.state.dialogMessage}
            dialogActionTitle={this.state.dialogActionTitle}
          />
          <div>
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleOpen}
            // disabled={isDisabled}
            />
          </div>
          <TextField
            floatingLabelText="Tenant Id"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.tenantId}
            name="name"
            style={styles.inputStyle}
            disabled
          />
          <TextField
            floatingLabelText="Order Token"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.orderToken}
            name="name"
            style={styles.inputStyle}
            disabled
          />
          <br />
          <div style={{ marginTop: '20px', display: 'inline-block', width: '400px', float: 'left' }}>
            <ul style={{ marginTop: '20px' }}>
              <li>
                <Checkbox
                  label="Apply Sales Tax To Pickup Orders"
                  defaultChecked={this.state.settings.taxPickupOrders}
                  name="taxPickupOrders"
                  onCheck={this.handleChange}
                // disabled={isDisabled}
                />
              </li>
              <li>
                <Checkbox
                  label="Apply Sales Tax To Shipped Orders"
                  defaultChecked={this.state.settings.taxShippedOrders}
                  name="taxShippedOrders"
                  onCheck={this.handleChange}
                // disabled={isDisabled}
                />
              </li>
            </ul>
          </div>
          <div style={{ marginTop: '20px', display: 'inline-block', width: '60%', float: 'left' }}>
            <SelectField
              value={this.state.settings.taxStates}
              multiple={isTrue}
              onChange={(event, index, value) => this.handleSelectChange(event, index, value, 'taxStates')}
              floatingLabelText="Taxable States *"
              name="taxStates"
              style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
              floatingLabelStyle={styles.floatingLabelStyle}
              errorText={this.state.required.taxStates}
              errorStyle={{ color: cyan500 }}
              disabled={this.state.controls.taxStatesDisabled}
            >
              {stateSelect}
            </SelectField>
          </div>
          <div className="firstOptionsDiv" style={{ paddingTop: '20px' }}>
            <div className="deliveryOptions" style={{ width: '235px' }}>Tax Shipped Orders Based On:</div>
            <RadioButtonGroup
              onChange={this.handleChange}
              name="taxByBillingAddress"
              valueSelected={this.state.settings.taxByBillingAddress}
              style={{ width: '400px', display: 'flex' }}
            >
              <RadioButton
                value={isTrue}
                label="Billing Address"
                style={styles.radioButton}
                disabled={this.state.controls.taxByBillingAddressDisabled}
              />
              <RadioButton
                value={isFalse}
                label="Shipping Address"
                style={styles.radioButton}
                disabled={this.state.controls.taxByBillingAddressDisabled}
              />
            </RadioButtonGroup>
          </div>
          <div style={{ fontSize: '12px' }}>
            *  Tax Rates are available by zip code for these states. If your state is not listed please contact us.
          </div>
        </div>
        <br />
        <br />
        <h2>Promo Ribbon Options</h2>
        <div className="content">
          <TextField
            floatingLabelText="Promo Text"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.promoText}
            name="promoText"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Promo Text2"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.promoText2}
            name="promoText2"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Promo Text3"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.promoText3}
            name="promoText3"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Promo Subtext"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.promoSubtext}
            name="promoSubtext"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Promo Text Mobile"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.promoTextMobile}
            name="promoTextMobile"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Promo Text2 Mobile"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.promoText2Mobile}
            name="promoText2Mobile"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Promo Text3 Mobile"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.promoText3Mobile}
            name="promoText3Mobile"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Promo Subtext Mobile"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.promoSubtextMobile}
            name="promoSubtextMobile"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Promo Color"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.promoColor}
            name="promoColor"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Promo Highlight Color"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.promoHighlightColor}
            name="promoHighlightColor"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Promo Background Color"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.promoBackgroundColor}
            name="promoBackgroundColor"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Promo Link"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.promoLink}
            name="promoLink"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
        </div>
        <CountDownOptions styles={styles} settings={this.state.settings} handleChange={this.handleChange} />
        <h2>Shipping Options</h2>
        <div className="content">
          {this.renderShippingOptions()}
        </div>
        <br />
        <br />
        <h2>Global Layout Options</h2>
        <div className="content">
          <TextField
            value={this.state.settings.clientLogo || ''}
            floatingLabelText="Client Logo URL"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="clientLogo"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <SelectField
            value={this.state.settings.layout}
            onChange={(event, index, value) => this.handleSelectChange(event, index, value, 'layout')} // eslint-disable-line max-len
            floatingLabelText="Display Template"
            style={{ marginTop: '-25px', verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="layout"
            floatingLabelStyle={styles.floatingLabelStyle}
          >
            <MenuItem value="default" primaryText="Default" />
            <MenuItem value="variation-2" primaryText="Variation-2" />
            <MenuItem value="variation-3" primaryText="Variation-3" />
          </SelectField>
          <SelectField
            value={this.state.settings.theme}
            onChange={(event, index, value) => this.handleSelectChange(event, index, value, 'theme')} // eslint-disable-line max-len
            floatingLabelText="Display Theme"
            style={{ marginTop: '-25px', verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="theme"
            floatingLabelStyle={styles.floatingLabelStyle}
          >
            <MenuItem value="default" primaryText="Default" />
            <MenuItem value="variation-2" primaryText="Variation-2" />
            <MenuItem value="variation-3" primaryText="Variation-3" />
          </SelectField>
          <br />
          <br />
          <TextField
            value={this.state.settings.heroImg.desktop || ''}
            floatingLabelText="Desktop Hero Image URL"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="heroImg.desktop"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <button
            className="filestack-button"
            onClick={(e) => {
              e.preventDefault;
              return client.picker({
                uploadInBackground: false,
                onUploadDone: ((res) => {
                  console.log('RES From filestack', res);
                  const targetName = 'heroImg.desktop'
                  const targetValue = res.filesUploaded[0].url ? res.filesUploaded[0].url : ''
                  this.handleUploadedImage(targetName, targetValue)
                })
              }).open()
            }}
            style={dropzoneStyles}>
            <p className="filestack-uplaod">Upload Desktop Hero Image</p>
          </button>
          <br />
          <br />
          <TextField
            value={this.state.settings.heroImg.mobile || ''}
            floatingLabelText="Mobile Hero Image URL"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="heroImg.mobile"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <button
            className="filestack-button"
            onClick={(e) => {
              e.preventDefault;
              return client.picker({
                uploadInBackground: false,
                onUploadDone: ((res) => {
                  console.log('RES From filestack', res);
                  const targetName = 'heroImg.mobile'
                  const targetValue = res.filesUploaded[0].url ? res.filesUploaded[0].url : ''
                  this.handleUploadedImage(targetName, targetValue)
                })
              }).open()
            }}
            style={dropzoneStyles}>
            <p className="filestack-uplaod">Upload Mobile Hero Image</p>
          </button>
          <br />
          <TextField
            value={this.state.settings.videoId || ''}
            floatingLabelText="Tv Commercial Video"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="videoId"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
        </div>
        <h2>Global SEO Options</h2>
        <div className="content">
          <TextField
            floatingLabelText="SEO Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.seoName || ''}
            name="seoName"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="SEO Title"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.seoTitle || ''}
            name="seoTitle"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="SEO Description"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.settings.seoDescription || ''}
            name="seoDescription"
            onChange={this.handleChange}
            style={styles.inputStyle}
            multiLine={true}
          />
        </div>
        <br />
        <br />
        <h2>Global Shipping Options (OLD)</h2>
        <div className="content">
          <TextField
            value={this.state.settings.flatShippingRate || 0}
            floatingLabelText="Shipping Rate"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="flatShippingRate"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <Checkbox
            label="Free Shipping"
            defaultChecked={this.state.settings.setFreeShipping}
            name="setFreeShipping"
            onCheck={this.handleChange}
          />
        </div>
        <ProductionOptions
          styles={styles}
          settings={this.state.settings}
          handleChange={this.handleChange}
          handleSelectChange={this.handleSelectChange}
        />
        <UpsellOptions
          styles={styles}
          settings={this.state.settings}
          handleChange={this.handleChange}
        />
        <br />
        <br />
      </div>
    );
  }
}

ShowSettings.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ShowSettings.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    taxStates: state.taxrates.states,
    settings: state.globalSettings.data,
    error: state.settings.error,
  };
}

export default connect(mapStateToProps)(ShowSettings);



// WEBPACK FOOTER //
// ./src/components/settings/ShowSettings.js